import { Paper, Typography } from '@mui/material';
import React from 'react';
import { useTranslate } from 'react-admin';
import CustomInput from '../../components/customInput/CustomInput';
import MyCustomImageUploader from '../../components/imageInput/MyCustomImageUploader';
import { SettingModel } from '../../config/types/models/SettingModel';
import { useAwsUpload } from '../../dataProviders/useAwsUpload';

type IProps = {
  setting: SettingModel;
  setSetting: (s: SettingModel) => void;
};

function PaymentSetting({ setting, setSetting }: IProps) {
  const t = useTranslate();

  return (
    <Paper sx={{ padding: 2, marginTop: 2 }}>
      <Typography variant='subtitle2'>{t('paymentSettings')}</Typography>
      <CustomInput
        value={setting?.CURRENCY || ''}
        onChange={(e) => {
          setSetting({ ...setting, CURRENCY: e.target.value });
        }}
        label={t('CURRENCY')}
      />

      <CustomInput
        value={setting?.QUICKPAY_API_URL || ''}
        onChange={(e) => {
          setSetting({ ...setting, QUICKPAY_API_URL: e.target.value });
        }}
        label={t('QUICKPAY_API_URL')}
      />

      <CustomInput
        value={setting?.QUICKPAY_API_KEY || ''}
        onChange={(e) => {
          setSetting({ ...setting, QUICKPAY_API_KEY: e.target.value });
        }}
        label={t('QUICKPAY_API_KEY')}
      />

      <CustomInput
        value={setting?.BANK_TYPE || ''}
        onChange={(e) => {
          setSetting({ ...setting, BANK_TYPE: e.target.value });
        }}
        label={t('BANK_TYPE')}
      />

      <CustomInput
        value={setting?.BANK_ACCOUNT || ''}
        onChange={(e) => {
          setSetting({ ...setting, BANK_ACCOUNT: e.target.value });
        }}
        label={t('BANK_ACCOUNT')}
      />

      <CustomInput
        value={setting?.IBAN_NUMBER || ''}
        onChange={(e) => {
          setSetting({ ...setting, IBAN_NUMBER: e.target.value });
        }}
        label={t('IBAN_NUMBER')}
      />

      <CustomInput
        value={setting?.MOMS_NUMBER || ''}
        onChange={(e) => {
          setSetting({ ...setting, MOMS_NUMBER: e.target.value });
        }}
        label={t('MOMS_NUMBER')}
      />

      <CustomInput
        value={setting?.ORDER_EXPIRES_AFTER || ''}
        type='number'
        onChange={(e) => {
          setSetting({
            ...setting,
            ORDER_EXPIRES_AFTER: parseInt(e.target.value),
          });
        }}
        label={t('ORDER_EXPIRES_AFTER')}
      />
    </Paper>
  );
}

export default PaymentSetting;
